import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

/** Shared field heights for inputs, select triggers and field-like picker buttons. */
const controlSizes = {
  default: "h-10",
  sm: "h-8",
} as const;

const inputVariants = cva(
  [
    "flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm shadow-sm",
    "transition-[border-color,box-shadow] duration-150",
    "placeholder:text-muted-foreground/70",
    "focus-visible:border-primary focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary/20",
    "disabled:cursor-not-allowed disabled:opacity-50",
    "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
  ].join(" "),
  {
    variants: {
      size: controlSizes,
    },
    defaultVariants: {
      size: "default",
    },
  }
);

export interface InputProps
  extends Omit<React.ComponentProps<"input">, "size">, VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, size, ...props }, ref) => {
    return (
      <input type={type} className={cn(inputVariants({ size, className }))} ref={ref} {...props} />
    );
  }
);
Input.displayName = "Input";

export { Input, controlSizes };
